import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const dict = {
  es: {
    "nav.shop": "Catálogo",
    "nav.subscribe": "Newsletter",
    "nav.about": "Sobre",
    "nav.contact": "Contacto",
    "nav.wishlist": "Favoritos",

    "wishlist.title": "Favoritos",
    "wishlist.lead": "Los discos que has marcado. Se guardan en este navegador.",
    "wishlist.empty": "Aún no tienes discos guardados. Pulsa el corazón en cualquier disco para empezar.",
    "wishlist.browse": "Ir al catálogo",
    "wishlist.one": "disco guardado",
    "wishlist.many": "discos guardados",
    "wishlist.clear": "Vaciar",

    "share.title": "Compartir",
    "share.copy": "Copiar enlace",
    "share.copied": "Enlace copiado",
    "share.whatsapp": "WhatsApp",
    "share.twitter": "Twitter / X",
    "share.telegram": "Telegram",
    "share.email": "Email",

    "detail.unique": "Único ejemplar disponible",

    "catalog.chip.under20": "Bajo 20 €",
    "catalog.chip.under30": "Bajo 30 €",
    "catalog.chip.newWeek": "Última semana",
    "catalog.chip.clear": "Limpiar",

    "home.intro": "Maggie Records. Tienda de vinilos en Valencia. Selección rotativa. Catálogo sincronizado con Discogs.",
    "home.intro.suffix": "{n} discos disponibles ahora mismo.",
    "home.latest.title": "Novedades",
    "home.latest.viewAll": "Ver todo",
    "home.viewFullCatalog": "Ver catálogo completo",
    "home.empty": "Sin discos disponibles.",
    "home.byGenre": "Más en el catálogo",
    "home.viewGenre": "Ver todos",
    "home.newsletter.copy": "Avisos de novedades y recomendaciones. Un email cada dos semanas, sin más.",
    "home.newsletter.title": "Newsletter",
    "home.tiers.lead": "Tres niveles. Sin permanencia. Cancela cuando quieras.",
    "home.cta.shop": "Ver catálogo",
    "home.cta.plans": "Suscripciones",
    "home.tiers.title": "Suscripciones",
    "home.tiers.plan": "Plan",
    "home.tiers.popular": "MÁS PEDIDO",
    "home.tiers.always": "siempre",
    "home.tiers.month": "/ mes",
    "home.tiers.free.cta": "Apuntarme",
    "home.tiers.early.cta": "Suscribirme",
    "home.tiers.curator.cta": "Quiero el pack",

    "newsletter.title": "Newsletter",
    "newsletter.moreOptions": "Planes de pago",
    "newsletter.page.title": "Newsletter.",
    "newsletter.page.lead": "Avisos de novedades y recomendaciones del mes. Un email cada dos semanas. Sin spam, sin secciones rellenas.",
    "newsletter.plans.title": "Planes de pago",
    "newsletter.plans.lead": "Suscripciones opcionales para quien quiere acceso anticipado o asesoramiento.",
    "newsletter.tier.subscribe": "Suscribirme",
    "newsletter.tier.redirecting": "Redirigiendo…",
    "newsletter.tier.free": "Gratis",
    "newsletter.tier.month": "€ / mes",
    "newsletter.tier.secure": "Pago con Stripe. Cancela cuando quieras.",
    "newsletter.form.email": "tu@email.com",
    "newsletter.form.submit": "Suscribirse",
    "newsletter.form.submitting": "…",

    "tier.free.perks.1": "Newsletter cada dos semanas",
    "tier.free.perks.2": "Avisos de novedades",
    "tier.free.perks.3": "Recomendaciones por email",
    "tier.early.perks.1": "Todo lo del plan Free",
    "tier.early.perks.2": "Acceso a novedades 48h antes",
    "tier.early.perks.3": "Reserva prioritaria",
    "tier.curator.perks.1": "Todo lo anterior",
    "tier.curator.perks.2": "Pack mensual de discos seleccionados",
    "tier.curator.perks.3": "Asesoramiento musical por email",

    "catalog.title": "Catálogo",
    "catalog.disc": "disco",
    "catalog.discs": "discos",
    "catalog.filters": "Filtros",
    "catalog.openFilters": "Filtros",
    "catalog.clear": "Limpiar",
    "catalog.search": "Buscar artista, título, sello, ref.",
    "catalog.sort": "Orden",
    "catalog.price": "Precio (€)",
    "catalog.min": "Mín",
    "catalog.max": "Máx",
    "catalog.genre": "Género",
    "catalog.style": "Estilo",
    "catalog.format": "Formato",
    "catalog.decade": "Década",
    "catalog.mediaCond": "Condición disco",
    "catalog.sleeveCond": "Condición carátula",
    "catalog.country": "País",
    "catalog.label": "Sello",
    "catalog.labelSearch": "Buscar sello…",
    "catalog.empty": "Sin resultados con esos filtros.",
    "catalog.prev": "← Anterior",
    "catalog.next": "Siguiente →",
    "catalog.page": "Página",
    "catalog.showResults": "Ver resultados",
    "sort.recent": "Más recientes",
    "sort.priceAsc": "Precio: menor a mayor",
    "sort.priceDesc": "Precio: mayor a menor",
    "sort.yearAsc": "Año: antiguo a nuevo",
    "sort.yearDesc": "Año: nuevo a antiguo",
    "sort.artistAsc": "Artista A–Z",
    "filters.noOptions": "Sin opciones",

    "detail.back": "Catálogo",
    "detail.preview": "Preescuchar",
    "detail.specs.format": "Formato",
    "detail.specs.year": "Año",
    "detail.specs.country": "País",
    "detail.specs.label": "Sello",
    "detail.specs.catno": "Catálogo",
    "detail.specs.media": "Condición disco",
    "detail.specs.sleeve": "Condición carátula",
    "detail.specs.genres": "Géneros",
    "detail.specs.styles": "Estilos",
    "detail.notes": "Notas del vendedor",
    "detail.price": "Precio",
    "detail.buy": "Hacer pedido",
    "detail.safe": "No pagas nada al pedir: te confirmamos disponibilidad y envío, y pagas por PayPal.",
    "detail.player": "Preescucha",
    "detail.videoUnavailable": "Vídeo no disponible",
    "detail.tracklist": "Tracklist",
    "detail.notFound": "Disco no encontrado.",
    "detail.backLink": "Volver al catálogo",

    "about.title": "Sobre.",
    "about.body.default": "Maggie Records. Vendemos vinilos desde 2023. En esta web tienes todo lo que tenemos disponible en este momento.\n\nPuedes pedir cualquier disco desde aquí: te confirmamos que está disponible, te decimos el coste del envío y pagas por PayPal.",

    "contact.title": "Contacto.",
    "contact.lead": "Para encargos, ofertas de venta o cualquier consulta. Respondemos en menos de 48h.",
    "contact.name": "Nombre",
    "contact.email": "Email",
    "contact.message": "Mensaje",
    "contact.send": "Enviar",
    "contact.sending": "Enviando…",
    "contact.success": "Mensaje recibido. Respondemos pronto.",
    "contact.error": "No se pudo enviar.",

    "footer.location": "Valencia · España",
    "footer.catalog": "Catálogo",
    "footer.newsletter": "Newsletter",
    "footer.about": "Sobre",
    "footer.contact": "Contacto",

    "toast.subscribed": "Suscrito. Te llegará un email de confirmación.",
    "toast.subscribeFail": "No se pudo completar la suscripción.",
    "toast.emailInvalid": "Email no válido.",
    "toast.checkoutFail": "No se pudo iniciar el pago.",

    "pay.confirming": "Pago",
    "pay.takes": "Confirmando…",
    "pay.success.kicker": "Pago confirmado",
    "pay.success.title": "Suscripción activa.",
    "pay.success.copy.curator": "Te hemos suscrito al plan Curator Pack. Revisa tu email.",
    "pay.success.copy.early": "Te hemos suscrito al plan Early Access. Revisa tu email.",
    "pay.success.cta": "Volver al catálogo",
    "pay.error.title": "El pago no se completó.",
    "pay.error.expired": "La sesión caducó.",
    "pay.error.timeout": "No hemos recibido confirmación.",
    "pay.error.generic": "Error verificando el pago.",
    "pay.error.back": "Volver a planes",
  },
  en: {
    "nav.shop": "Catalog",
    "nav.subscribe": "Newsletter",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.wishlist": "Wishlist",

    "wishlist.title": "Wishlist",
    "wishlist.lead": "The records you've saved. Stored in this browser.",
    "wishlist.empty": "No saved records yet. Tap the heart on any record to start.",
    "wishlist.browse": "Browse catalog",
    "wishlist.one": "saved record",
    "wishlist.many": "saved records",
    "wishlist.clear": "Clear",

    "share.title": "Share",
    "share.copy": "Copy link",
    "share.copied": "Link copied",
    "share.whatsapp": "WhatsApp",
    "share.twitter": "Twitter / X",
    "share.telegram": "Telegram",
    "share.email": "Email",

    "detail.unique": "Only one copy available",

    "catalog.chip.under20": "Under 20 €",
    "catalog.chip.under30": "Under 30 €",
    "catalog.chip.newWeek": "Last 7 days",
    "catalog.chip.clear": "Clear",

    "home.intro": "Maggie Records. Record shop based in Valencia. Rotating selection. Inventory synced from Discogs.",
    "home.intro.suffix": "{n} records available right now.",
    "home.latest.title": "New arrivals",
    "home.latest.viewAll": "See all",
    "home.viewFullCatalog": "View full catalog",
    "home.empty": "No records available.",
    "home.byGenre": "More from the catalog",
    "home.viewGenre": "See all",
    "home.newsletter.copy": "New arrivals notices and picks. One email every two weeks. Nothing else.",
    "home.newsletter.title": "Newsletter",
    "home.tiers.lead": "Three tiers. No commitment. Cancel anytime.",
    "home.cta.shop": "View catalog",
    "home.cta.plans": "Subscriptions",
    "home.tiers.title": "Subscriptions",
    "home.tiers.plan": "Plan",
    "home.tiers.popular": "MOST CHOSEN",
    "home.tiers.always": "forever",
    "home.tiers.month": "/ mo",
    "home.tiers.free.cta": "Sign me up",
    "home.tiers.early.cta": "Subscribe",
    "home.tiers.curator.cta": "I want the pack",

    "newsletter.title": "Newsletter",
    "newsletter.moreOptions": "Paid plans",
    "newsletter.page.title": "Newsletter.",
    "newsletter.page.lead": "New arrivals notices and monthly picks. One email every two weeks. No spam, no filler.",
    "newsletter.plans.title": "Paid plans",
    "newsletter.plans.lead": "Optional paid plans for those who want early access or advice.",
    "newsletter.tier.subscribe": "Subscribe",
    "newsletter.tier.redirecting": "Redirecting…",
    "newsletter.tier.free": "Free",
    "newsletter.tier.month": "€ / mo",
    "newsletter.tier.secure": "Stripe payment. Cancel any time.",
    "newsletter.form.email": "you@email.com",
    "newsletter.form.submit": "Subscribe",
    "newsletter.form.submitting": "…",

    "tier.free.perks.1": "Newsletter every two weeks",
    "tier.free.perks.2": "New arrivals notices",
    "tier.free.perks.3": "Email recommendations",
    "tier.early.perks.1": "Everything in Free",
    "tier.early.perks.2": "New arrivals 48h earlier",
    "tier.early.perks.3": "Priority hold requests",
    "tier.curator.perks.1": "Everything above",
    "tier.curator.perks.2": "Monthly hand-picked pack",
    "tier.curator.perks.3": "Music advice by email",

    "catalog.title": "Catalog",
    "catalog.disc": "record",
    "catalog.discs": "records",
    "catalog.filters": "Filters",
    "catalog.openFilters": "Filters",
    "catalog.clear": "Clear",
    "catalog.search": "Search artist, title, label, ref.",
    "catalog.sort": "Sort",
    "catalog.price": "Price (€)",
    "catalog.min": "Min",
    "catalog.max": "Max",
    "catalog.genre": "Genre",
    "catalog.style": "Style",
    "catalog.format": "Format",
    "catalog.decade": "Decade",
    "catalog.mediaCond": "Media condition",
    "catalog.sleeveCond": "Sleeve condition",
    "catalog.country": "Country",
    "catalog.label": "Label",
    "catalog.labelSearch": "Search label…",
    "catalog.empty": "No results with those filters.",
    "catalog.prev": "← Previous",
    "catalog.next": "Next →",
    "catalog.page": "Page",
    "catalog.showResults": "Show results",
    "sort.recent": "Newest first",
    "sort.priceAsc": "Price: low to high",
    "sort.priceDesc": "Price: high to low",
    "sort.yearAsc": "Year: old to new",
    "sort.yearDesc": "Year: new to old",
    "sort.artistAsc": "Artist A–Z",
    "filters.noOptions": "No options",

    "detail.back": "Catalog",
    "detail.preview": "Preview",
    "detail.specs.format": "Format",
    "detail.specs.year": "Year",
    "detail.specs.country": "Country",
    "detail.specs.label": "Label",
    "detail.specs.catno": "Cat. no.",
    "detail.specs.media": "Media condition",
    "detail.specs.sleeve": "Sleeve condition",
    "detail.specs.genres": "Genres",
    "detail.specs.styles": "Styles",
    "detail.notes": "Seller notes",
    "detail.price": "Price",
    "detail.buy": "Place order",
    "detail.safe": "Ordering is free: we confirm availability and shipping, then you pay by PayPal.",
    "detail.player": "Preview",
    "detail.videoUnavailable": "Video unavailable",
    "detail.tracklist": "Tracklist",
    "detail.notFound": "Record not found.",
    "detail.backLink": "Back to catalog",

    "about.title": "About.",
    "about.body.default": "Maggie Records. We've been selling vinyl since 2023. This website shows everything we have available right now.\n\nYou can order any record here: we confirm it's available, tell you the shipping cost and you pay by PayPal.",

    "contact.title": "Contact.",
    "contact.lead": "For orders, sale offers or any question. We reply in under 48h.",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.send": "Send",
    "contact.sending": "Sending…",
    "contact.success": "Message received. We'll be in touch.",
    "contact.error": "Could not send.",

    "footer.location": "Valencia · Spain",
    "footer.catalog": "Catalog",
    "footer.newsletter": "Newsletter",
    "footer.about": "About",
    "footer.contact": "Contact",

    "toast.subscribed": "Subscribed. You'll get a confirmation email.",
    "toast.subscribeFail": "Could not complete subscription.",
    "toast.emailInvalid": "Invalid email.",
    "toast.checkoutFail": "Could not start checkout.",

    "pay.confirming": "Payment",
    "pay.takes": "Confirming…",
    "pay.success.kicker": "Payment confirmed",
    "pay.success.title": "Subscription active.",
    "pay.success.copy.curator": "You're subscribed to the Curator Pack plan. Check your inbox.",
    "pay.success.copy.early": "You're subscribed to the Early Access plan. Check your inbox.",
    "pay.success.cta": "Back to catalog",
    "pay.error.title": "Payment failed.",
    "pay.error.expired": "Session expired.",
    "pay.error.timeout": "We didn't get confirmation.",
    "pay.error.generic": "Error verifying the payment.",
    "pay.error.back": "Back to plans",
  },
};

const I18nCtx = createContext({ lang: "es", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem("vmr_lang") || "es";
  });

  useEffect(() => {
    localStorage.setItem("vmr_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => dict[lang]?.[key] ?? dict.es[key] ?? key, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
